import { render, staticRenderFns } from "./addAffiliateRule.vue?vue&type=template&id=84794a74"
import script from "./addAffiliateRule.vue?vue&type=script&lang=js"
export * from "./addAffiliateRule.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports